// extracted by mini-css-extract-plugin
module.exports = {"imagesWrapper":"VariantModal_imagesWrapper__2zSwG","modalTitle":"VariantModal_modalTitle__2UBDu","sizeBtn":"VariantModal_sizeBtn__awstW"};